var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex align-items-center" },
      [
        _c(
          "div",
          { staticClass: "w-100" },
          [
            _c("label", [_vm._v(_vm._s(_vm.label))]),
            _c("v-select", {
              class: {
                "v-select-danger": _vm.danger,
                "select-size-sm": _vm.small
              },
              attrs: {
                placeholder: "Busque por código o nombre",
                options: _vm.communes,
                name: _vm.name,
                value: _vm.optionSelected,
                disabled: _vm.isDisabled,
                clearable: _vm.isClearable
              },
              on: { input: _vm.onInput }
            })
          ],
          1
        ),
        _c("vs-icon", {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: "Eliminar comuna",
              expression: "'Eliminar comuna'"
            }
          ],
          staticClass: "ml-2 mt-5 pt-1 cursor-pointer",
          attrs: {
            icon: "remove_circle_outline",
            size: "small",
            color: "danger"
          },
          on: { click: _vm.clearCommune }
        })
      ],
      1
    ),
    _vm.danger
      ? _c("div", [
          _c("small", [
            _c("span", { staticClass: "text-danger" }, [
              _vm._v(" " + _vm._s(_vm.dangerText) + " ")
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }